"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _equality = require("../../utils/equality");
class AuComponent extends _react.default.Component {
  shouldComponentUpdate = _equality.smartShouldComponentUpdate;
}
exports.default = AuComponent;